import(/* webpackMode: "eager" */ "/vercel/path0/src/app/revendedores/page.tsx");
